import { registerPlugin } from '@capacitor/core';

import type { CapacitorIBeaconScanningPlugin } from './definitions';

const CapacitorIBeaconScanning = registerPlugin<CapacitorIBeaconScanningPlugin>('CapacitorIBeaconScanning', {
  web: () => import('./web.js').then((m) => new m.CapacitorIBeaconScanningWeb()),
});

export * from './definitions';
export { CapacitorIBeaconScanning };
